import { Component, OnInit, ViewChild, ChangeDetectorRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { permitedMenuLinks } from '../admin.component';
import { AdminDashboardService } from '../admin-services/admin-dashboard.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OrganisationService } from '../organisation/services/organisation.service';
import { AdminGraphAnalytic } from './model/admin-graph-analytic';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { PieChartComponent } from './graph/pie-chart/pie-chart.component';
import { error } from 'util';
import { QuizReviewComponent } from './quiz-review/quiz-review.component';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EncriptDecriptService } from '../../../services/encriptdecript';
declare var $;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public dashboardMenuLinks = permitedMenuLinks.slice(1);
  public basic_table_data: any;

  @ViewChild('expTable') expTable: any;
  @ViewChild('studentTable') studentTable: any;
  @ViewChild('coursePie') coursePieChartComponent: PieChartComponent;
  @ViewChild('studentPie') studentPieChartComponent: PieChartComponent;
  @ViewChild('search') search: any;

  public $courseStatusData = new BehaviorSubject({});
  public $studentStatusData = new BehaviorSubject({});

  condensedTableDataMap = {
    title: null,
    places: null,
    condensed: null,
  };
  list = [1, 2, 3, 4, 5];
  // No Option YET
  // https://github.com/swimlane/ngx-datatable/issues/423
  scrollBarHorizontal = (window.innerWidth < 960);
  columnModeSetting = (window.innerWidth < 960) ? 'standard' : 'force';
  columnModeSettingSmall = (window.innerWidth < 560) ? 'standard' : 'force';
  courseArrayList = [];
  topicArrayList = [];
  sectionArrayList = [];
  userArrayList = [];

  public displayCourse = [];
  public courseNav: any = [];
  public courseColumns = [];
  public organisationArray: any = [];
  public courseName: any;
  public topicName: any;
  // public courseStatisTics = [];
  public analyticsMode: string;
  public statusKeys: any = [];
  public statusValues: any = [];
  public statusList: any[];
  public selectedStatusValue: any;
  public selectedCourseObject: any;
  public selectedTopicObject: any;
  public selectedSectionObject: any;
  public coursePercentage = [];
  public studentPercentage = [];
  public StudentData;
  public courseData;
  /**
   * @description  - Student Code Start
   * */

  public studentStatistics = [];
  public studentTopicArrayList = [];
  public studentSectionArrayList = [];
  public displayStudents = [];
  public cloneDisplayStudents = [];

  public studentColumns = [];
  public studentNav = [];
  public studentName: any;
  public studentCourseName: any;
  public CategoryArrayList = [];
  public studentArrayList = [];
  public selectedCourse: any;

  //<--------------------  Course Code end ------------------>
  public selectedTopic: any;
  public selectedOrganisation;
  yetToStart = '';
  completed = '';
  inprogress = '';
  quizAttemptsList: any = [];
  modalCourseFlag = false;
  modalFlag = false;
  public userObject: any;
  courseAttempt: boolean = false;
  searchUser ="";

  constructor(private router: Router, private route: ActivatedRoute,
    private adminDashboardService: AdminDashboardService,
    private fromBuilder: FormBuilder, private organisationService: OrganisationService,
    private cd: ChangeDetectorRef, private modalService: NgbModal,
    private encriptDecript: EncriptDecriptService,
  ) {
    // console.log(this.columnModeSetting);
    this.fetch((data) => {
      this.basic_table_data = data;
    });

    window.onresize = () => {
      this.scrollBarHorizontal = (window.innerWidth < 960);
      this.columnModeSetting = (window.innerWidth < 960) ? 'standard' : 'force';
      this.columnModeSettingSmall = (window.innerWidth < 560) ? 'standard' : 'force';
    };
  }

  fetch(cb) {
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/table.json`);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  toggleExpandRow(row) {
    // console.log(row);
    this.expTable.rowDetail.toggleExpandRow(row);
  }

  ngOnInit() {
    this.getAdminDashboardStatus();
  }


  changeOrganisation(event) {
    this.selectedOrganisation = event;
    const change = 'changeOrgId';
    this.getAdminDashboardAnalytics(event.organisationId, change);
  }


  getAdminDashboardAnalytics(orgId, change) {
    this.completed = '';
    this.inprogress = '';
    this.yetToStart = '';
    this.adminDashboardService.getAdminDashboardAnalytics(orgId).subscribe(
      (res: AdminGraphAnalytic) => {
        this.displayCourse = [];
        this.displayStudents = [];
        this.cloneDisplayStudents = [];
        this.userArrayList = [];
        this.topicArrayList = [];
        this.sectionArrayList = [];
        this.studentArrayList = [];
        this.studentCourseName = [];
        this.courseName = '';
        this.topicName = '';
        this.studentName = '';
        this.selectedTopic = '';
        this.selectedCourse = '';
        this.selectedCourseObject = '';
        this.selectedTopicObject = '';
        this.courseNav = [0];
        this.studentNav = [0];
        console.log('admin Dashboard service response ======> ');
        this.$courseStatusData.next(res.categoryAnalytics);
        this.coursePercentage = res.categoryAnalytics != null ? res.categoryAnalytics.analyticsStatus : null;
        this.$studentStatusData.next(res.userAnalytics);
        this.studentPercentage = res.userAnalytics != null ? res.userAnalytics.analyticsStatus : null;
        if (res.userAnalytics != null) {
          if (res.userAnalytics.analyticsStatus[1].percentage == 0) {
            this.completed = 'CO';
          }
          if (res.userAnalytics.analyticsStatus[0].percentage == 0) {
            this.yetToStart = 'YS';
          }
          if (res.userAnalytics.analyticsStatus[2].percentage == 0) {
            this.inprogress = 'IP';
          }
          if (change == 'changeOrgId') {
            this.coursePieChartComponent.ngAfterViewInit();
            this.studentPieChartComponent.ngAfterViewInit();
          }
        }
      }, (error) => {
        if (error.status == 401) {
        }
      }
    );
  }


  courseAnalyticData(event) {
    this.analyticsMode = 'Course';
    this.completed = '';
    this.yetToStart = '';
    this.inprogress = '';
    // to disabled the status dropdown
    if (this.coursePercentage[1].percentage == 0) {
      this.completed = 'CO';
    }
    if (this.coursePercentage[0].percentage == 0) {
      this.yetToStart = 'YS';
    }
    if (this.coursePercentage[2].percentage == 0) {
      this.inprogress = 'IP';
    }
    // to change course graph status to table status 
    this.courseData = event;
    if (event.data.statusCode == 'IP') {
      for (let value of this.statusList) {
        if (value.value == 'IP') {
          this.selectedStatusValue = value;
        }
      }
    }
    if (event.data.statusCode == 'CO') {
      for (let value of this.statusList) {
        if (value.value == 'CO') {
          this.selectedStatusValue = value;
        }
      }
    }
    if (event.data.statusCode == 'YS') {
      for (let value of this.statusList) {
        if (value.value == 'YS') {
          this.selectedStatusValue = value;
        }
      }
    }

    var courseIds = event.data.idList;
    var orgId = this.selectedOrganisation.organisationId;

    return this.adminDashboardService
      .getAdminDashBoardCourseAnalyticsViewApi(orgId, courseIds).subscribe((Response => {

        this.courseArrayList = [...Response.data];
        this.courseArrayList = [...this.courseArrayList];
        this.courseNav = [0];
        this.displayCourse = [...Response.data];
        this.courseColumns = [
          ['COURSES', 'categoryName'],
          ['NO OF STUDENTS', 'userCount'],
          ['AVERAGE TIME SPENT', 'averageTimeSpent']
        ];
        this.displayCourse = [...this.displayCourse];
        this.courseColumns = [...this.courseColumns];
        document.getElementById("courseTableDiv").click();
      }));
  }

  studentAnalyticData(event) {
    this.analyticsMode = 'Student';
    this.completed = '';
    this.yetToStart = '';
    this.inprogress = '';
    // to disabled the status dropdown
    if (this.studentPercentage[1].percentage == 0) {
      this.completed = 'CO';
    }
    if (this.studentPercentage[0].percentage == 0) {
      this.yetToStart = 'YS';
    }
    if (this.studentPercentage[2].percentage == 0) {
      this.inprogress = 'IP';
    }

    // to change student graph status to table status 
    if (event.data.statusCode == 'IP') {
      for (let value of this.statusList) {
        if (value.value == 'IP') {
          this.selectedStatusValue = value;
        }
      }
    }
    if (event.data.statusCode == 'CO') {
      for (let value of this.statusList) {
        if (value.value == 'CO') {
          this.selectedStatusValue = value;
        }
      }
    }
    if (event.data.statusCode == 'YS') {
      for (let value of this.statusList) {
        if (value.value == 'YS') {
          this.selectedStatusValue = value;
        }
      }
    }

    this.StudentData = event.data;
    var userIds = this.StudentData['idList'];
    var orgId = this.selectedOrganisation.organisationId;


    return this.adminDashboardService.
      getAdminDashBoardStudentAnalyticsView(userIds, orgId).subscribe((Response => {
        this.analyticsMode = 'Student';
        this.studentNav = [0];
        this.studentColumns = [
          ['STUDENTS', 'userName'],
          ['STATUS', 'statusPercentage'],
          ['TOTAL TIME SPENT', 'totalTimeSpent']
        ];
        this.displayStudents = Response.data;
        this.displayStudents = [...this.displayStudents];

        this.cloneDisplayStudents = Response.data;;
        this.cloneDisplayStudents = [...this.displayStudents];

        this.studentColumns = [...this.studentColumns];
        if (event.data) { document.getElementById("studentTableDiv").click(); }
        this.studentStatistics = [...Response.data];
        this.studentArrayList = this.studentStatistics;
      }));


  }

  // To get the Course or Student Analytics  based on the status like IP,CO and YS
  changeStatus(event) {

    if (this.analyticsMode == 'Course') {
      if (event.value == 'YS') {
        this.coursePieChartComponent
          .toggleArc(this.coursePieChartComponent.ystArcData,
            this.coursePieChartComponent.ystPath);
      }
      if (event.value == 'CO') {
        this.coursePieChartComponent
          .toggleArc(this.coursePieChartComponent.completedArcData,
            this.coursePieChartComponent.coPath);
      }
      if (event.value == 'IP') {
        this.coursePieChartComponent
          .toggleArc(this.coursePieChartComponent.inProgressArcData,
            this.coursePieChartComponent.ipPath);
      }

    }
    if (this.analyticsMode == 'Student') {

      if (event.value == 'YS') {
        this.studentPieChartComponent
          .toggleArc(this.studentPieChartComponent.ystArcData,
            this.studentPieChartComponent.ystPath);
      }
      if (event.value == 'CO') {
        this.studentPieChartComponent
          .toggleArc(this.studentPieChartComponent.completedArcData,
            this.studentPieChartComponent.coPath);
      }
      if (event.value == 'IP') {
        this.studentPieChartComponent
          .toggleArc(this.studentPieChartComponent.inProgressArcData,
            this.studentPieChartComponent.ipPath);
      }

    }
  }

  //  get Status List for Course And Student
  getAdminDashboardStatus() {
    this.adminDashboardService.getAdminDashBoardStatus().subscribe((Response) => {
      this.statusKeys = Object.keys(Response);
      this.statusValues = Object.values(Response);
      this.getOrganizationList();
      let count = 0;
      var arr = [];
      for (let key of this.statusKeys) {
        let obj = {
          'key': key,
          'value': this.statusValues[count]
        };
        arr.push(obj);
        count++;
      }
      this.statusList = arr;
      for (let value of this.statusList) {
        if (value.value == 'YS') {
          this.selectedStatusValue = value;
        }
      }
    }, (error) => {
      if (error.status == 401) {
      }
      else {
        this.getOrganizationList();
      }
    });
  }

  //  get organizationList
  getOrganizationList() {
    this.userObject = this.encriptDecript.getLocalStorage('userObject');
    const obj = JSON.parse(this.userObject);
    if (obj.isAdmin === true) {
      let orgId = obj.organisation.organisationId;
      this.organisationService.getOrganisationViewList(orgId, true).subscribe(
        response => {
          this.organisationArray = [...response.data];
          const orgId = this.organisationArray[0].organisationId;
          this.selectedOrganisation = this.organisationArray[0];
          this.getAdminDashboardAnalytics(orgId, '');
        }, (error) => {
          if (error.status == 401) {
          }
          else {
            this.getAdminDashboardAnalytics(orgId, '');
          }
        });
    } else {
      let orgId = obj.organisation.organisationId;
      this.organisationService.getOrganisationViewList(orgId, true).subscribe(
        response => {
          this.organisationArray = [...response.data];
          const orgId = this.organisationArray[0].organisationId;
          this.selectedOrganisation = this.organisationArray[0];
          this.getAdminDashboardAnalytics(orgId, '');
        }, (error) => {
          if (error.status == 401) {
          }
          else {
            this.getAdminDashboardAnalytics(orgId, '');
          }
        });
    }
  }

  /**
   * @description  -> //<--------------------   Course Starting Code  -------------------->
   */

  //  to get admin dashboard course statistics
  getAdminDashBoardCourseAnalytics(event) {
    var courseIds;
    var orgId;
    if (event.value == 'YS') {
      courseIds = this.coursePercentage[0].idList;
      orgId = this.selectedOrganisation.organisationId;
    }
    if (event.value == 'CO') {
      courseIds = this.coursePercentage[1].idList;
      orgId = this.selectedOrganisation.organisationId;
    }
    if (event.value == 'IP') {
      courseIds = this.coursePercentage[2].idList;
      orgId = this.selectedOrganisation.organisationId;
    }

    return this.adminDashboardService
      .getAdminDashBoardCourseAnalyticsViewApi(orgId, courseIds).subscribe((Response => {

        // this.analyticsMode = 'Course';
        this.courseArrayList = [...Response.data];
        this.courseArrayList = [...this.courseArrayList];
        this.courseNav = [0];
        this.displayCourse = [...Response.data];
        this.courseColumns = [
          ['COURSES', 'categoryName'],
          ['NO OF STUDENTS', 'userCount'],
          ['AVERAGE TIME SPENT', 'averageTimeSpent']
        ];
        this.displayCourse = [...this.displayCourse];
        this.courseColumns = [...this.courseColumns];
      }), (error) => {
        this.displayCourse = [];
        this.courseNav = [0];
      });

  }

  onSelectCourse(event) {
    if (event.type == 'click') {
      var access = Object.keys(event.row);
      if (!access.includes('userName')) {
        this.courseNav = Object.keys(event.row);
        if (this.courseNav.includes('categoryName')) {
          this.courseColumns = [
            ['TOPICS', 'courseName'],
            ['NO OF STUDENTS', 'userCount'],
            ['AVERAGE TIME SPENT', 'averageTimeSpent']
          ];
          this.selectedCourseObject = event.row;
          this.courseName = event.row.categoryName;
          var payLoad = event.row.categoryOrganisationIdentity;
          if (payLoad) {
            this.adminDashboardService.
              getTopicsForSelectedCourse(
                payLoad.categoryId,
                payLoad.organisationId).subscribe(response => {
                  if (response.data) {
                    this.topicArrayList = response.data;
                    this.displayCourse = this.topicArrayList;
                  }
                });
          }
        }
        if (this.courseNav.includes('courseName')) {
          this.courseColumns = [
            ['SECTIONS', 'lessonName'],
            ['NO OF STUDENTS', 'userCount'],
            ['AVERAGE TIME SPENT', 'averageTimeSpent']
          ];
          this.selectedTopicObject = event.row;
          this.topicName = event.row.courseName;
          var payLoad = event.row.courseOrganisationIdentity;
          if (payLoad) {
            this.adminDashboardService.
              getSectionsForSelectedTopic(
                payLoad.courseId,
                payLoad.organisationId).subscribe(response => {
                  if (response.data) {
                    this.sectionArrayList = response.data;
                    this.displayCourse = this.sectionArrayList;
                  }
                });
          }
        }
        if (this.courseNav.includes('lessonName')) {
          this.displayCourse = [];
          this.courseColumns = [
            ['STUDENTS', 'userName'],
            ['STATUS', 'status'],
            ['TOTAL TIME SPENT', 'totalTimeSpent']
          ];
          this.selectedSectionObject = event.row;
          var payLoad = event.row.lessonOrganisationIdentity;
          if (payLoad) {
            this.adminDashboardService.
              getStudentsForSelectedSection(
                payLoad.lessonId,
                payLoad.organisationId).subscribe(response => {
                  if (response.data) {
                    this.userArrayList = this.getData(response.data);
                    this.displayCourse = this.userArrayList;
                  }
                });
          }
        }
      }
    }
  }

  getArrayList(name) {
    this.courseNav = [name];
    if (this.courseNav.includes('categoryName')) {
      this.courseColumns = [
        ['TOPICS', 'courseName'],
        ['NO OF STUDENTS', 'userCount'],
        ['AVERAGE TIME SPENT', 'averageTimeSpent']
      ];
      this.displayCourse = this.topicArrayList;
    }
    if (this.courseNav.includes('courseName')) {

      this.courseColumns = [
        ['SECTIONS', 'lessonName'],
        ['NO OF STUDENTS', 'userCount'],
        ['AVERAGE TIME SPENT', 'averageTimeSpent']
      ];
      this.displayCourse = this.sectionArrayList;
    }
  }

  onChangeCourse(event) {
    var access = Object.keys(event);
    if (access.includes('categoryName')) {
      this.courseColumns = [
        ['TOPICS', 'courseName'],
        ['NO OF STUDENTS', 'userCount'],
        ['AVERAGE TIME SPENT', 'averageTimeSpent']
      ];
      this.courseName = event.categoryName;
      var payLoad = event.categoryOrganisationIdentity;
      if (payLoad) {
        this.adminDashboardService.
          getTopicsForSelectedCourse(
            payLoad.categoryId,
            payLoad.organisationId).subscribe(response => {
              if (response.data) {
                this.topicArrayList = response.data;
                this.displayCourse = this.topicArrayList;
              }
            });
      }
    }

    if (access.includes('courseName')) {
      this.courseColumns = [
        ['SECTIONS', 'lessonName'],
        ['NO OF STUDENTS', 'userCount'],
        ['AVERAGE TIME SPENT', 'averageTimeSpent']
      ];
      this.topicName = event.courseName;

      var payLoad = event.courseOrganisationIdentity;
      if (payLoad) {
        this.adminDashboardService.
          getSectionsForSelectedTopic(
            payLoad.courseId,
            payLoad.organisationId).subscribe(response => {
              if (response.data) {
                this.sectionArrayList = response.data;
                this.displayCourse = this.sectionArrayList;
              }
            });
      }
    }
    if (access.includes('lessonName')) {
      this.displayCourse = [];
      this.courseColumns = [
        ['STUDENTS', 'userName'],
        ['STATUS', 'status'],
        ['TOTAL TIME SPENT', 'totalTimeSpent']
      ];
      // event.lessonUserAnalyticsView.forEach(element => {
      //   if (element.contentType == 'QUIZ') {
      //     element.status = element.quizStatus;
      //   }
      //   this.displayCourse.push(element);
      // });
      var payLoad = event.lessonOrganisationIdentity;
      if (payLoad) {
        this.adminDashboardService.
          getStudentsForSelectedSection(
            payLoad.lessonId,
            payLoad.organisationId).subscribe(response => {
              if (response.data) {
                this.userArrayList = this.getData(response.data);
                this.displayCourse = this.userArrayList;
              }
            });
      }
    }
  }


  //<--------------------   Course End Code  -------------------->




  //<--------------------   Student Start Code  -------------------->


  //  to get admin dashboard student statistics userCourseAnalyticsView
  getAdminDashBoardStudentAnalytics(event) {
    if (event.idList != undefined) {
      if (event.statusCode == 'YS') {
        var userIds = this.studentPercentage[0].idList;
        var orgId = this.selectedOrganisation.organisationId;
        this.selectedStatusValue = { 'key': 'Yet To Start', 'value': 'YS' };
      }
      if (event.statusCode == 'CO') {
        var userIds = this.studentPercentage[1].idList;
        var orgId = this.selectedOrganisation.organisationId;
        this.selectedStatusValue = { 'key': 'Completed', 'value': 'CO' };
      }
      if (event.statusCode == 'IP') {
        var userIds = this.studentPercentage[2].idList;
        var orgId = this.selectedOrganisation.organisationId;
        this.selectedStatusValue = { 'key': 'In Progress', 'value': 'IP' };
      }
    }
    return this.adminDashboardService
      .getAdminDashBoardStudentAnalyticsView(userIds, orgId).subscribe((Response => {
        this.analyticsMode = 'Student';
        this.studentNav = [0];
        this.studentColumns = [
          ['STUDENTS', 'userName'],
          ['STATUS', 'statusPercentage'],
          ['TOTAL TIME SPENT', 'totalTimeSpent']
        ];
        this.displayStudents = Response.data;
        this.displayStudents = [...this.displayStudents];

        this.cloneDisplayStudents = Response.data;
        this.cloneDisplayStudents = [...this.cloneDisplayStudents];
        
        this.studentColumns = [...this.studentColumns];
        this.studentStatistics = [...Response.data];
        this.studentArrayList = this.studentStatistics;
      }), (error) => {
        this.displayStudents = [];
        this.cloneDisplayStudents = [];
        this.studentNav = [0];
      });

  }

  onChangeStudentCourse(event, level) {
    if (level == 1) {
      this.studentCourseName = event.categoryName;
      this.displayStudents = [];
      this.cloneDisplayStudents = [];

      var payLoad = event.userCategoryOrganisationIdentity;
      if (payLoad) {
        this.adminDashboardService.
          getTopicsForSelectedStudent(
            payLoad.userId,
            payLoad.categoryId,
            payLoad.organisationId).subscribe(response => {
              // console.log(response);
              if (response.data) {
                this.displayStudents = this.getData(response.data);
                this.cloneDisplayStudents = this.getData(response.data);

                this.studentTopicArrayList = this.displayStudents;
                this.studentColumns = [
                  ['TOPICS', 'courseName'],
                  ['STATUS', 'statusPercentage'],
                  ['TOTAL TIME SPENT', 'totalTimeSpent']
                ];
              }
            });
      }
      else {
        this.displayStudents = [];
        this.cloneDisplayStudents = [];
      }
    };
    if (level == 2) {
      this.displayStudents = [];
      this.cloneDisplayStudents = [];

      var payLoad = event.userCourseOrganisationIdentity;
      if (payLoad) {
        this.adminDashboardService.
          getSectionsForSelectedStudent(
            payLoad.userId,
            payLoad.courseId,
            payLoad.organisationId
          ).subscribe(response => {
            //  console.log(response);
            if (response.data) {
              this.studentSectionArrayList = response.data;
              this.studentColumns = [
                ['SECTIONs', 'lessonName'],
                ['STATUS', 'statusPercentage'],
                ['TOTAL TIME SPENT', 'averageTimeSpent']
              ];
              this.displayStudents = this.getData(response.data);
              this.cloneDisplayStudents = this.getData(response.data);
            }
          });
      }
    }
  }

  // if does it contain any quiz type change statuspecentage to quiz remarks pass or fail 

  getData(data) {
    var arry = [];
    data.forEach(element => {
      if (element.contentType == 'QUIZ') {
        if (element.statusPercentage!=null&&element.statusPercentage==0||element.statusPercentage) {
          element.statusPercentage = element.quizStatus;
        } else if (element.status) {
          element.status = element.quizStatus;
        }
      }
      arry.push(element);
    });
    return arry;
  }

  onSelectStudent(event) {
    if (event.type == 'click') {
      this.studentNav = Object.keys(event.row);
      if (this.studentNav.includes('userName')) {
        this.studentName = event.row.userName;
        this.displayStudents = [];
        this.cloneDisplayStudents = [];
        this.studentColumns = [
          ['COURSES', 'categoryName'],
          ['STATUS', 'statusPercentage'],
          ['TOTAL TIME SPENT', 'totalTimeSpent']
        ];
        var payLoad = event.row.userOrganisationIdentity;
        if (payLoad) {
          this.adminDashboardService.
            getCoursesForSelectedStudent(
              payLoad.userId,
              payLoad.organisationId
            ).subscribe(response => {
              //  console.log(response);
              if (response.data) {
                this.displayStudents = response.data;
                this.cloneDisplayStudents = response.data;
                this.CategoryArrayList = response.data;
              }

            });
        }
      }
      if (this.studentNav.includes('categoryName')) {
        this.studentCourseName = event.row.categoryName;
        this.selectedCourse = event.row;
        this.displayStudents = [];
        this.cloneDisplayStudents = [];
        var payLoad = event.row.userCategoryOrganisationIdentity;
        if (payLoad) {
          this.adminDashboardService.
            getTopicsForSelectedStudent(
              payLoad.userId,
              payLoad.categoryId,
              payLoad.organisationId
            ).subscribe(response => {
              //  console.log(response);
              if (response.data) {
                this.studentTopicArrayList = response.data;
                this.studentColumns = [
                  ['TOPICS', 'courseName'],
                  ['STATUS', 'statusPercentage'],
                  ['TOTAL TIME SPENT', 'totalTimeSpent']
                ];
                this.displayStudents = this.getData(response.data);
                this.cloneDisplayStudents = this.getData(response.data);
              }
            });
        }
      }
      if (this.studentNav.includes('courseName')) {
        this.displayStudents = [];
        this.cloneDisplayStudents = [];
        this.selectedTopic = event.row;
        var payLoad = event.row.userCourseOrganisationIdentity;
        if (payLoad) {
          this.adminDashboardService.
            getSectionsForSelectedStudent(
              payLoad.userId,
              payLoad.courseId,
              payLoad.organisationId
            ).subscribe(response => {
              //   console.log(response);
              if (response.data) {
                this.studentSectionArrayList = response.data;
                this.studentColumns = [
                  ['SECTIONS', 'lessonName'],
                  ['STATUS', 'statusPercentage'],
                  ['TOTAL TIME SPENT', 'averageTimeSpent']
                ];
                this.displayStudents = this.getData(response.data);
                this.cloneDisplayStudents = this.getData(response.data);
                
              }
            });
        }
      }
    }
  }


  goBackStudent(name) {
    this.studentNav = [name];
    if (this.studentNav.includes('0')) {
      this.studentColumns = [
        ['STUDENTS', 'userName'],
        ['STATUS', 'statusPercentage'],
        ['AVERAGE TIME SPENT', 'totalTimeSpent']
      ];
      this.studentArrayList = this.studentStatistics;
      this.displayStudents = this.studentArrayList;
      this.cloneDisplayStudents = this.studentArrayList;
    }
    if (this.studentNav.includes('categoryName')) {
      this.studentColumns = [
        ['TOPICS', 'courseName'],
        ['STATUS', 'statusPercentage'],
        ['TOTAL TIME SPENT', 'totalTimeSpent']
      ];
      this.displayStudents = this.studentTopicArrayList;
      this.studentArrayList = this.studentTopicArrayList;
    }
  }
  //<--------------------  Student Code end ------------------>


  getUserAttemps(event) {
    this.quizAttemptsList = [];
    if (event.lessonUserOrganisationIdentity) {
      this.adminDashboardService.getUserAttemps(event.lessonUserOrganisationIdentity).subscribe(response => {
        this.quizAttemptsList = response;
        if (this.quizAttemptsList.length == 0) {
          this.courseAttempt = true;
        } else {
          this.courseAttempt = false;
        }
      });
    }
  }

  getCourseAttemps(event) {
    this.quizAttemptsList = [];

    if (event.lessonUserOrganisationIdentity) {
      this.adminDashboardService.getUserAttemps(event.lessonUserOrganisationIdentity).subscribe(response => {
        this.quizAttemptsList = response;
        if (this.quizAttemptsList.length == 0) {
          this.courseAttempt = true;
        } else {
          this.courseAttempt = false;
        }
      });
    }
  }

  openQuizReviewForUserModal(obj) {
    if (obj.startDate) {
      const modalConfig: any = {
        backdrop: 'static',
        size: 'xl',
      };
      const modalRef = this.modalService.open(QuizReviewComponent, modalConfig);
      modalRef.componentInstance.lessonObject = obj;
      modalRef.componentInstance.listOfAttempts = this.quizAttemptsList;
    }
  }

  openQuizReviewForCourseModal(obj) {
    if (obj.startDate) {
      const modalConfig: any = {
        backdrop: 'static',
        size: 'xl',
      };
      const modalRef = this.modalService.open(QuizReviewComponent, modalConfig);
      modalRef.componentInstance.lessonObject = obj;
      modalRef.componentInstance.listOfAttempts = this.quizAttemptsList;
    }
  }s

  eventSearchUser(){
  
  // public displayStudents = [];
  // public cloneDisplayStudents = [];
  
  let val = this.searchUser;
  let value = val.toString().toLowerCase().trim();
  let temp = [];
    if(this.searchUser){
      temp = this.cloneDisplayStudents.filter((item) => {
        // if(item.userName.toString().toLowerCase().trim() == value.toString().toLowerCase().trim()){
        //   return true;
        // }
        if(item.userName.toString().toLowerCase().trim().indexOf(value) !== -1){
          return true;
        }
      });
      console.log(temp);
      this.displayStudents = [...temp];
    }else{
      this.displayStudents = [...this.cloneDisplayStudents]
    }

  }


}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/dashboard/dashboard.component.ts